import React, { Fragment, createElement, useCallback } from 'react';
import { CloseIcon } from '../../assets/icons/CloseIcon';
import useScreenSize from '../../hooks/useScreenSize/useScreenSize';
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils';
import IconButton from '../iconButton/IconButton';
import { ModalProps } from '../modal/Modal';
import VideoPlayer, { VideoPlayerProps } from '../videoPlayer/VideoPlayer';
import './VideoModal.scss';
const rootClassName = 'video-modal';

type omit = 'footer' | 'title' | 'compenseColPaddingContent';
interface VideoModalProps extends Omit<ModalProps, omit> {
  urlVideo?: string;
  videoPlayerProps?: VideoPlayerProps;
}

export default function VideoModal({
  className,
  id,
  mobileOn,
  modalKey,
  onClose,
  preventEscExit,
  preventMaskExit,
  size,
  tag = 'dialog',
  urlVideo,
  videoPlayerProps,
  ...props
}: VideoModalProps) {
  const { rankedSize } = useScreenSize();

  const handleClose = useCallback(() => {
    onClose?.(modalKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, modalKey]);

  return createElement(
    tag,
    {
      ...props,
      id: id ?? modalKey ?? `modal${getUniqueKey()}`,
      className: getMergedClassNames([
        rootClassName,
        className || '',
        mobileOn !== undefined && rankedSize <= mobileOn ? 'mobile' : '',
        `${rootClassName}-${String(size).toLowerCase()}`,
      ]),
    },
    <Fragment>
      <div className={`${rootClassName}-close-button`}>
        <IconButton onClick={handleClose} icon={<CloseIcon />} />
      </div>
      <div className={`${rootClassName}-video-row`}>
        <VideoPlayer blackGround {...(videoPlayerProps ?? {})} url={urlVideo} />
      </div>
    </Fragment>
  );
}

VideoModal.defaultProps = {
  size: 'md',
};
